import React from "react";

function NotificationCard({ notification }) {
  return (
    <div className="notification-card">
      <h4>{notification.title}</h4>
      <p>{notification.message}</p>
      <small>{notification.timestamp}</small>
    </div>
  );
}

export default NotificationCard;
